import { render, staticRenderFns } from "./FormatListView.vue?vue&type=template&id=5966208c&scoped=true&"
import script from "./FormatListView.vue?vue&type=script&lang=ts&"
export * from "./FormatListView.vue?vue&type=script&lang=ts&"
import style0 from "./FormatListView.vue?vue&type=style&index=0&id=5966208c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5966208c",
  null
  
)

export default component.exports